import viewingImage from './scroll-to-section';
import scrollToSection from './viewing-image/viewing-image';

window.addEventListener('DOMContentLoaded', () => {
	scrollToSection();
	viewingImage();
});
